import {
  DownOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, Form, Modal, Select, Tree } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { authenticateToken } from "../../../utils/auth";
import Loading from "../../common/Loader";

import { responseNotification } from "../../../utils/notify";
import ShopLayout from "../Layout";
import _ from "lodash";
import ShopHeader from "../Layout/topHeader";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
const { DirectoryTree } = Tree;
const { Option } = Select;

const ShopCategory = () => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const [type, setType] = useState<string>(shopInfo?.type);
  const [categoryName, setCategoryName] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState("");
  const [visible, setVisible] = useState(undefined);
  const [isModalVisible, setIsModalVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = React.useState(false);

  const [categoryOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoryId, setCategoryId] = useState<any>();
  const [categoryData, setCategoryData] = useState(undefined);
  const [categoryListData, setCategoryListData] = useState({
    loading: false,
    data: null,
  });
  const route = useParams();
  const [selectedCategory, setSelectedCategory] = useState(undefined);
  const [form] = Form.useForm();

  // All Category List For Add Category
  const getCategoriesOptions = useCallback(
    async (key) => {
      if (shopInfo?.type === "JC_MART") {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${shopInfo?.id}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category: any) => {
            return {
              value: category?.category?.id,
              label: category?.category?.title,
            };
          }),
        });
      } else {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/category/search?page=0&limit=20&type=${type}&isParent=true&key=${key}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map(
            (category: { id: any; title: any }) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }
          ),
        });
      }
    },
    [key]
  );

  useEffect(() => {
    if (type && isModalVisible) {
      getCategoriesOptions("");
    }
  }, [getCategoriesOptions, isModalVisible, type]);

  const fetchRef = useRef(0);
  const categorySearchDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getCategoriesOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getCategoriesOptions]);

  // Category List By Shop ID
  const getShopCategory = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setCategoryListData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/categories?shopId=${getShopId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setCategoryListData({
                loading: false,
                data: data?.data,
              });
            } else {
              setCategoryListData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setCategoryListData({ loading: false, data: null });
            console.log(err);
          });
      } catch (error) {
        setCategoryListData({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    getShopCategory((route as any)?.shopId);
  }, [getShopCategory, route]);

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      categories: data.categoryId.map((category: any, index: string) => ({
        categoryId: category,
        displayOrder:
          index +
          1 +
          (categoryListData?.data?.categories?.[
            categoryListData?.data?.categories?.length - 1
          ]?.displayOrder * 1 || 0),
      })),
      shopId: shopInfo?.id,
    };

    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-shop`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Category Assigned Successfully", "success");
          getShopCategory(shopInfo?.id);
          form.resetFields();
          handleOk();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const onRemoveServiceGroup = () => {
    Modal.confirm({
      title: "Do you confirm?",
      icon: <ExclamationCircleOutlined />,
      content: `Will you confirm to remove this category from this shop?`,
      okText: "Remove",
      cancelText: "Cancel",
      onOk: async () => {
        if (categoryId) {
          await fetch(
            `${process.env.REACT_APP_CATALOG_WRITER_API}/category-shop`,
            {
              method: "PUT",
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                categories: [
                  {
                    categoryId: categoryId,
                    displayOrder: 0,
                  },
                ],
                shopId: shopInfo.id,
                deleted: true,
              }),
            }
          )
            .then((res) => res.json())
            .then((res) => {
              if (res.statusCode === 200) {
                responseNotification(
                  "Category Deleted Successfully",
                  "success"
                );
                getShopCategory(shopInfo.id);
                setVisible(undefined);
              } else if (res.status === 500) {
                responseNotification("Internal server error", "error");
              } else {
                responseNotification(
                  res.message || "something wrong",
                  "warning"
                );
              }
            })
            .catch((err) => {
              responseNotification(
                `${"Internal server error"} ${err}`,
                "error"
              );
              console.error("err", err);
            });
        }
      },
    });
  };

  useEffect(() => {
    if (visible) {
      onRemoveServiceGroup();
    }
  }, [visible]);

  const changeOrder = async (pos, node) => {
    let curr;
    let item;

    categoryListData?.data?.categories?.find((category, i) => {
      if (category?.category?.id === node?.key) {
        curr = i;
        item = category;
      }
    });

    const formated =
      curr !== pos &&
      _.concat(
        curr < pos
          ? categoryListData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(0, pos - 1)
          : categoryListData?.data?.categories?.slice(0, pos),
        item,
        curr > pos
          ? categoryListData?.data?.categories
              ?.filter((_, i) => i !== curr)
              ?.slice(pos, categoryListData?.data?.categories?.length - 1)
          : categoryListData?.data?.categories?.slice(
              pos,
              categoryListData?.data?.categories?.length
            )
      )?.map((item, i) => ({
        categoryId: item?.category?.id,
        displayOrder: i + 1,
      }));

    if (formated) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category-shop`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          categories: formated,
          shopId: shopInfo?.id,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            getShopCategory(shopInfo?.id);
            responseNotification("Position Updated Successfully", "success");
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const showPopconfirm = (id) => {
    setVisible(id);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setVisible(undefined);
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (visible) {
      setSelectedCategory(undefined);
    }
  }, [selectedCategory, selectedCategory]);

  useEffect(() => {
    setSelectedCategory(undefined);
  }, [visible]);

  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="product-list-item-area white-bg">
          <ShopHeader
            leftarea={"Category List"}
            rightarea={
              <div className="">
                <Button
                  danger
                  type="primary"
                  icon={<PlusOutlined />}
                  title="Add Product"
                  onClick={showModal}
                >
                  Add Category
                </Button>
              </div>
            }
          />

          <div className="pt-3">
            {categoryListData?.loading ? (
              <Loading />
            ) : (
              <div className="product-table-area details-area">
                <DirectoryTree
                  height={600}
                  draggable
                  showLine
                  multiple
                  showIcon={false}
                  switcherIcon={<DownOutlined />}
                  treeData={categoryListData?.data?.categories.map(
                    (category) => ({
                      title: category?.category?.title,
                      key: category?.category?.id,
                      children: category?.categories?.map((child) => ({
                        title: child?.categories?.title,
                        key: child?.categories?.id,
                      })),
                    })
                  )}
                  onDrop={(e) => {
                    changeOrder(e.dropPosition, e.dragNode);
                  }}
                  onRightClick={(val) => {
                    setCategoryId(val?.node?.key);
                    setCategoryName(val?.node?.title);
                    setVisible(val?.node?.key);
                    console.log(val);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </ShopLayout>

      <Modal
        title="Assign Category"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
          initialValues={{
            ...categoryListData,
          }}
        >
          <Form.Item
            hasFeedback
            label="Select Category"
            name="categoryId"
            rules={[
              {
                required: true,
                message: "Pleasse Select Minimum One Category!",
              },
            ]}
          >
            <Select
              disabled={!categoryListData?.data ? true : false}
              allowClear
              showSearch
              placeholder="Search Category"
              optionFilterProp="children"
              onChange={(val) => setCategoryId(val)}
              onSearch={categorySearchDebounce}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0 ||
                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
              }
              // options={categoryOptions?.list}
              mode="multiple"
            >
              {categoryOptions.list.map((category: any) => (
                <Option value={category?.value}>{category.label}</Option>
              ))}
            </Select>
          </Form.Item>

          <div className="buttons-container mt-3">
            <Button
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => form?.resetFields()}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default ShopCategory;
